/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { RegistryOfficeResponse } from '../../models/registry-office-response';

export interface OfficeControllerGetAll$Params {
  query?: string;
  country_iso?: string;
  related_registry_id?: number;
  province?: string;
  city?: string;
  office_types?: Array<number> | null;

/**
 * Se true, la lista comprende anche le sedi di sistema dei magazzini (guasti, RAEE, smarriti), escluse di default
 */
  include_special?: boolean;
  limit: number;
  skip: number;
  order_by?: string;
  order_direction?: string;
}

export function officeControllerGetAll(http: HttpClient, rootUrl: string, params: OfficeControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('country_iso', params.country_iso, {});
    rb.query('related_registry_id', params.related_registry_id, {});
    rb.query('province', params.province, {});
    rb.query('city', params.city, {});
    rb.query('office_types', params.office_types, {});
    rb.query('include_special', params.include_special, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryOfficeResponse;
      }>;
    })
  );
}

officeControllerGetAll.PATH = '/registry/office/list';
